import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow, MaskedLines } from "@/components/site/Motion";
import { SERVICES } from "@/data/products";

const Row = ({ s, i }) => (
  <Reveal delay={i * 0.06}>
    <Link
      to={`/kontakt?subject=${encodeURIComponent(s.t)}`}
      data-testid={`service-row-${s.n}`}
      className="group grid grid-cols-12 gap-4 items-start py-8 border-t border-white/15 transition-[padding] duration-500 hover:lg:pl-6"
    >
      <span className="col-span-2 lg:col-span-1 font-mono text-sm text-[#7FE3EA] pt-2">{s.n}</span>
      <h3 className="col-span-10 lg:col-span-5 font-display text-2xl sm:text-4xl font-semibold tracking-tight text-white transition-colors duration-300 group-hover:text-[#7FE3EA]">{s.t}</h3>
      <p className="col-span-10 col-start-3 lg:col-span-5 lg:col-start-auto text-[#C9CDEA] leading-relaxed pt-1">{s.d}</p>
      <span className="hidden lg:grid col-span-1 justify-end pt-2">
        <ArrowRight className="w-6 h-6 text-white transition-transform duration-500 group-hover:translate-x-2" />
      </span>
    </Link>
  </Reveal>
);

export const Services = () => (
  <section id="tjanster" className="relative bg-[#070B2E] py-24 lg:py-36 overflow-hidden grain" data-testid="services-section">
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 mb-16">
        <div className="lg:col-span-7">
          <Eyebrow dark>Tjänster</Eyebrow>
          <MaskedLines as="h2" inView className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-[-0.03em] leading-[1] mt-4 text-white" lines={["Expertis som", "kompletterar systemet."]} />
        </div>
        <Reveal className="lg:col-span-5 lg:pt-10" delay={0.15}>
          <p className="text-base sm:text-lg text-[#C9CDEA] leading-relaxed">Från kvalitetskontroll av era konsulter till utbildning i Penningtvättlagen – vi hjälper byrån att arbeta tryggt och effektivt över tid.</p>
        </Reveal>
      </div>
      <div className="border-b border-white/15">
        {SERVICES.map((s, i) => <Row key={s.n} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
